// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"TooltipV2_tooltip__y7k1n","default":"TooltipV2_default__KgMPH","dark":"TooltipV2_dark__zCcnV","arrow":"TooltipV2_arrow__uKBgQ"};